/*
Copyright 2025 Adobe. All rights reserved.
This file is licensed to you under the Apache License, Version 2.0 (the "License");
you may not use this file except in compliance with the License. You may obtain a copy
of the License at http://www.apache.org/licenses/LICENSE-2.0

Unless required by applicable law or agreed to in writing, software distributed under
the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
OF ANY KIND, either express or implied. See the License for the specific language
governing permissions and limitations under the License.
*/

import { tag as html, TemplateResult } from '../custom-tag.js';

export { setCustomTemplateLiteralTag } from '../custom-tag.js';
export const ImageMapCircleIcon = ({
  width = 24,
  height = 24,
  hidden = false,
  title = 'Image Map Circle',
} = {}): string | TemplateResult => {
  return html`<svg
    xmlns="http://www.w3.org/2000/svg"
    height="${height}"
    viewBox="0 0 36 36"
    width="${width}"
    aria-hidden=${hidden ? 'true' : 'false'}
    role="img"
    fill="currentColor"
    aria-label="${title}"
  >
    <path
      d="M32 10.461V4.5a.5.5 0 0 0-.5-.5h-5.961a15.907 15.907 0 0 0-15.078 0H4.5a.5.5 0 0 0-.5.5v5.961a15.906 15.906 0 0 0 0 15.078V31.5a.5.5 0 0 0 .5.5h5.961a15.907 15.907 0 0 0 15.078 0H31.5a.5.5 0 0 0 .5-.5v-5.961a15.906 15.906 0 0 0 0-15.079ZM26 6h4v4h-4ZM6 6h4v4H6Zm4 24H6v-4h4Zm20 0h-4v-4h4Zm.537-6H24.5a.5.5 0 0 0-.5.5v6.038a13.778 13.778 0 0 1-12 0V24.5a.5.5 0 0 0-.5-.5H5.463a13.778 13.778 0 0 1 0-12H11.5a.5.5 0 0 0 .5-.5V5.462a13.778 13.778 0 0 1 12 0V11.5a.5.5 0 0 0 .5.5h6.037a13.778 13.778 0 0 1 0 12Z"
    />
  </svg>`;
};
